// Re-export related kaylee types to provide a more convenient import for the drivers.
export * from '../../../../kaylee/CallType';
export * from '../../../../kaylee/DriverCaps';
export * from '../../../../kaylee/EquipmentStates';
export * from '../../../../kaylee/KayleeRoomDiscoveredEquipment';
export * from '../../../../kaylee/RoomState';
export function isHttpDriver(Driver) {
    return Driver.driverType === 'httpDriver';
}
export function isSocketDriver(Driver) {
    return Driver.driverType === 'socketDriver';
}
export function isUdpDriver(Driver) {
    return Driver.driverType === 'udpDriver';
}
export const pollableControlNames = [
    'calendar',
    'cameras',
    'cameraSelected',
    'cameraTracking',
    'contactClosure',
    'directory',
    'displayBlank',
    'displayFreeze',
    'firmwareVersion',
    'mute',
    'name',
    'power',
    'serialNumber',
    'videoInput',
    'videoMatrixRoutes',
    'volume',
    'volumeMute',
];
